import { render, staticRenderFns } from "./page-tour.vue?vue&type=template&id=d0ef22fa&scoped=true&"
import script from "./page-tour.vue?vue&type=script&lang=js&"
export * from "./page-tour.vue?vue&type=script&lang=js&"
import style0 from "./page-tour.vue?vue&type=style&index=0&id=d0ef22fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ef22fa",
  null
  
)

export default component.exports